import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async saveAll() {
    const promises = []

    // Save all open cell-edit forms
    this.element.querySelectorAll("[data-controller='cell-edit']").forEach(el => {
      const form = el.querySelector("[data-cell-edit-target='form']")
      if (form && !form.classList.contains("hidden")) {
        const controller = this.application.getControllerForElementAndIdentifier(el, "cell-edit")
        if (controller) promises.push(controller.save())
      }
    })

    // Save all open row-edit forms
    this.element.querySelectorAll("[data-controller='row-edit']").forEach(el => {
      const form = el.querySelector("[data-row-edit-target='form']")
      if (form && !form.classList.contains("hidden")) {
        const controller = this.application.getControllerForElementAndIdentifier(el, "row-edit")
        if (controller) promises.push(controller.save())
      }
    })

    await Promise.all(promises)
  }
}
